import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from './../../../../../../Containers/Config/index';
import { CREATE_CAMPAIGN_RULE, CREATE_CAMPAIGN_RULE_SUCCESS, CREATE_CAMPAIGN_RULE_ERROR } from './../../../../actionType';
import apiCall from '../../../../apiCall';
import { Constant } from '../../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

// Persists the campaign's rules: deletes removed rules, updates the ones that were
// already created (PUT), and creates the new ones (POST) — so revisiting the step
// and editing never duplicates a rule. Returns the local-id → server-id map for the
// rules that still exist, which the Effects step needs to reference them.
function* createCampaignRule({ payload }) {
  try {
    const { campaignId, creates = [], updates = [], deletes = [] } = payload?.data || {};
    const headers = { ...customHeaders };
    delete headers['X-Requested-By'];
    const resultRules = [];

    // 1. Remove rules the user deleted after they were persisted.
    for (let i = 0; i < deletes.length; i++) {
      yield call(apiCall, {
        url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/campaign-rules/${deletes[i]}`,
        method: 'DELETE',
        headers,
      });
    }

    // 2. Update the rules that already exist.
    for (let i = 0; i < updates.length; i++) {
      const rule = updates[i];
      const response = yield call(apiCall, {
        url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/campaign-rules/${rule.ruleId}`,
        method: 'PUT',
        headers,
        data: rule.body,
      });

      if (response.status === 200 || response.status === 201) {
        resultRules.push({ localId: rule.localId, id: rule.ruleId, data: response?.data?.results || response?.data?.result || response?.data || {} });
      } else {
        cogoToast.error(response?.response?.data?.message || `Failed to update rule "${rule?.body?.name || ''}".`);
        yield put({ type: CREATE_CAMPAIGN_RULE_ERROR, payload: response?.response?.data?.message });
        return;
      }
    }

    // 3. Create the brand-new rules.
    for (let i = 0; i < creates.length; i++) {
      const rule = creates[i];
      const response = yield call(apiCall, {
        url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/campaign-rules`,
        method: 'POST',
        headers,
        data: rule.body,
      });

      if (response.status === 200 || response.status === 201) {
        const data = response?.data?.results || response?.data?.result || response?.data || {};
        resultRules.push({ localId: rule.localId, id: data?.objectId || data?.id || data?.rule_id, data });
      } else {
        cogoToast.error(response?.response?.data?.message || `Failed to create rule "${rule?.body?.name || ''}".`);
        yield put({ type: CREATE_CAMPAIGN_RULE_ERROR, payload: response?.response?.data?.message });
        return;
      }
    }

    cogoToast.success(`Rules saved successfully.`);
    yield put({
      type: CREATE_CAMPAIGN_RULE_SUCCESS,
      payload: resultRules,
    });
  } catch (error) {
    yield put({ type: CREATE_CAMPAIGN_RULE_ERROR, payload: error });
  }
}

export function* watchCreateCampaignRuleSaga() {
  yield takeEvery(CREATE_CAMPAIGN_RULE, createCampaignRule);
}

function* createCampaignRuleSaga() {
  yield all([fork(watchCreateCampaignRuleSaga)]);
}

export default createCampaignRuleSaga;
